export default function localImageSource(src) {
  return `/images/${src}`;
}
